import { render, staticRenderFns } from "./SalesmanStatistics.vue?vue&type=template&id=24c460f8&scoped=true&"
import script from "./SalesmanStatistics.vue?vue&type=script&lang=js&"
export * from "./SalesmanStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanStatistics.vue?vue&type=style&index=0&id=24c460f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c460f8",
  null
  
)

export default component.exports